var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('invite-client-buttons',{attrs:{"session":_vm.session,"team-language":_vm.session.team_language}})}
var staticRenderFns = []

export { render, staticRenderFns }